export const style = {
  list: {
    sx: {
      paddingLeft: 4,
    },
    item: {
      display: 'flex',
      flexDirection: 'column',
    },
    deepItem: {
      marginLeft: 15,
    },
  },
} as const;
